import {
  SHOW_OR_HIDE_COUOPON_REQUEST,
  SHOW_OR_HIDE_COUOPON_SUCCESS,
  SHOW_OR_HIDE_COUOPON_FAILURE
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_OR_HIDE_COUOPON_REQUEST:
      return { ...state, isLoading: true, error: null };
    case SHOW_OR_HIDE_COUOPON_SUCCESS:
    {
      if (action.tabType === 'coupon') {
        return { ...state, data: action.payload, isLoading: false, error: null };
      }
      return state;
    }
    case SHOW_OR_HIDE_COUOPON_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};